import React from 'react'
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FiYoutube } from "react-icons/fi";
import { assets } from '../../assets/assets';
import { MdOutlinePhone } from "react-icons/md";
import { MdOutlineEmail } from "react-icons/md";
import { LuMapPin } from "react-icons/lu";
import { Link } from 'react-router-dom';




const Footer = () => {
  return (
    <div>
      <footer className="footer_sec">
        <div className="container">
            <div className="row gy-4 gy-xl-0">
                <div className="col-xl-4">
                    <div className="footer-widget pe-xl-5">
                        <div className="logo mb-4">
                            <img src={assets.footer_logo} className="img-fluid" alt="Logo"/>
                        </div>
                        <p>
                            We are India's Trusted and Transparent Online Donation Platform, with a Vision to create a
                            Social Impact. We believe in 100% Satisfactory & Transparent Donation. We provide Photogenic
                            Proof, Video Conferencing and GPS Location.
                        </p>
                        <div className="social_media d-none d-sm-block mt-5">
                            <ul className="d-inline-flex align-items-center">
                                <li><Link to="https://www.facebook.com/ihskasfoundationngo/"><FaFacebookF /></Link></li>
                                <li><Link to="https://twitter.com/IhskasF"><FaXTwitter /></Link></li>
                                <li><Link to="https://www.instagram.com/ihskasfoundation/"><FaInstagram /></Link></li>
                                <li><Link to="https://www.youtube.com/channel/UCfrILL-fYtiJisx16tclsfw"><FiYoutube /></Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-6 col-lg-4 col-xl-2">
                    <div className="footer-widget mt-xl-5">
                        <div className="widget-title">
                            <h4>Quick Link</h4>
                        </div>
                        <div className="footer-link">
                            <ul>
                                <li><Link to="/about">About</Link></li>
                                <li><Link to="/contact">Contact</Link></li>
                                <li><Link to="/explore-campaign">Explore Campaign</Link></li>
                                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                <li><Link to="/refund-policy">Refund Policy</Link></li>
                                <li><Link to="/terms-service">Terms of Service</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-6 col-lg-4 col-xl-2">
                    <div className="footer-widget mt-xl-5">
                        <div className="widget-title">
                            <h4>Important Links</h4>
                        </div>
                        <div className="footer-link">
                            <ul>
                                <li><Link to="/faq">Faq's</Link></li>
                                <li><Link to="/blog">Blogs</Link></li>
                                <li><Link to="/gallery">Gallery</Link></li>
                                <li><Link to="/request-campaign">Request A Campaign</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-xl-4">
                    <div className="footer-widget mt-xl-5 ps-xl-5">
                        <div className="widget-title">
                            <h4>Get in Touch</h4>
                        </div>
                        <div className="footer-link">
                            <div className="d-flex align-items-center mb-3">
                                <div className="icon">
                                   <MdOutlinePhone/>
                                </div>
                                <div className="content">
                                    <span>Whatsapp Number</span>
                                    <p>91- 7800083019</p>
                                </div>
                            </div>
                            <div className="d-flex align-items-center mb-3">
                                <div className="icon">
                                    <MdOutlineEmail/>
                                </div>
                                <div className="content">
                                    <span>Email Us</span>
                                    <p>contact@ihskasfoundation.org</p>
                                </div>
                            </div>
                            <div className="d-flex align-items-center mb-3">
                                <div className="icon">
                                    <LuMapPin/>
                                </div>
                                <div className="content">
                                    <span>Location</span>
                                    <p>Dindapur, Jansa Varanasi
                                        UP-221405
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="social_media d-block d-sm-none mt-5">
                            <ul className="d-inline-flex align-items-center">
                            <li><a href="#"><FaFacebookF /></a></li>
                                <li><a href="#"><FaXTwitter /></a></li>
                                <li><a href="#"><FaInstagram /></a></li>
                                <li><a href="#"><FiYoutube /></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="copyright border-top border-light text-center pt-4 mt-4">
                <p>@ 2024 Ihskas Foundation | All right reserved </p>
            </div>
        </div>
    </footer>
    </div>
  )
}

export default Footer
